<template>
  <div class="main-wrapper">
    <div class="main">
      <div class="main-left">
        <div class="card-wrapper">
          <course-card
            v-if="indexInfo"
            :couruse-info="indexInfo.lately_learn_book"
            @change="onChange" />
          <div class="bottom">
            <exam-card @change="onChange" />
            <wrong-book-card @change="onChange" />
          </div>
        </div>
      </div>
      <div class="main-right">
        <sidebar
          v-if="indexInfo"
          :data="indexInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/index';
import CourseCard from './CourseCard.vue';
import ExamCard from './ExamCard.vue';
import WrongBookCard from './WrongBookCard.vue';
import Sidebar from './Sidebar.vue';

export default {
  components: {
    CourseCard,
    ExamCard,
    WrongBookCard,
    Sidebar,
  },
  data() {
    return {
      indexInfo: null,
    };
  },
  created() {
    this.getIndexInfo();
  },
  methods: {
    getIndexInfo() {
      api.getIndexInfo().then((res) => {
        this.indexInfo = res;
      });
    },
    onChange(params) {
      this.$emit('change', params);
    },
  },
};
</script>

<style lang="scss" scoped>
  .main-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    .main {
      display: flex;
      overflow: hidden;
      width: 100%;
      height: 100%;
      background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/17227050e20c32d3406f24454036de99.png');
      background-size: cover;
      .main-left {
        display: flex;
        justify-content: center;
        width: 71%;
        height: 100%;
        .card-wrapper {
          display: inline-block;
          .bottom {
            margin-top: 9vh;
            display: flex;
            justify-content: space-between;
          }
        }
      }
      .main-right {
        width: 31%;
        height: 100%;
      }
    }
  }
</style>
